import { Helmet } from "react-helmet-async";

export default function SEO({ title, description, image, url }) {
  const siteName = "Зорі — декор та фотошпалери";
  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  const currentUrl = typeof window !== "undefined" ? window.location.href : url;
  const metaDescription = description || "Декор та фотошпалери ручної роботи в Україні";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={currentUrl} />

      {/* Open Graph (Facebook, Telegram) */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="uk_UA" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
